<template>
    <div
        class="icon-grid-wrapper"
        :class="{ 'is-constrained': constrain }">

        <div class="icon-grid">
            <drop
                v-for="(item, index) in totalSquares"
                :key="index"
                :ref="'coordsSquares_' + uid"
                :uid="index"
                class="icon-grid-square"
                :style="coordsSquareStyle"
                @drop="dropItNow($event, index)">

                <span v-text="index"></span>

            </drop>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    import { Drop } from 'vue-drag-drop';
    import fileMixin from '../mixins.js';

    // http://marcj.github.io/css-element-queries/
    import ResizeSensor from 'css-element-queries/src/ResizeSensor';

    export default {
        components: {
            drop: Drop
        },
        mixins: [
            fileMixin
        ],
        props: {
            constrain: Boolean,
        },
        data() {
            return {
                boundaryWidth: null,
                boundaryHeight: null,
                squareWidth: 100, // TODO: let component control size of tiles and icons
                resizeTimeout: null,
                uid: Math.floor(100000 + Math.random() * 900000) // TODO: performance test - not full proof yet
            }
        },
        computed: {
            totalSquares() { // how many can fit into the space
                var totalX = Math.floor(this.boundaryWidth / this.squareWidth);
                var totalY = Math.floor(this.boundaryHeight / this.squareWidth); // caution: there is no squareHeight !!
                var totalSquares = Math.floor(totalX * totalY); //
                var totalItems = this.constrain;
                var excess = 0;

                // if we need to fit more icons than the space allows, the extras will be added
                if (totalItems > totalSquares) {
                    excess = totalItems - totalSquares;
                    // console.log('excess is: '+totalSquares);
                }
                return totalSquares + excess;
            },
            coordsSquareStyle() {
                return {
                    width: this.squareWidth + 'px',
                    height: this.squareWidth + 'px',
                    // fontSize: this.squareWidth/100 + 'rem' // TODO: measure icon in ems
                }
            }
        },
        mounted() {
            new ResizeSensor(this.$el, this.setStageArea);
            this.setStageArea();
        },
        beforeDestroy() {
            // window.removeEventListener('resize', this.resize);
        },
        methods: {
            ...mapActions('gameOS', [
                // 'updateIconPosition'
            ]),

            setStageArea() {
                this.boundaryWidth = this.$el.clientWidth;
                this.boundaryHeight = this.$el.clientHeight;
                this.$nextTick(this.broadcastCoords); // @@ BROADCAST @@
            },

            broadcastCoords() {
                var coordsArray = [];
                var coordSquareEls = this.$refs['coordsSquares_'+this.uid];

                // loop through $elements to get their X and Y and store as objects in array
                for (var i = 0; i < coordSquareEls.length; i++) {
                    coordsArray.push({
                        x: coordSquareEls[i].$el.getBoundingClientRect().left - coordSquareEls[i].$el.parentNode.getBoundingClientRect().left, // relative coords
                        y: coordSquareEls[i].$el.getBoundingClientRect().top - coordSquareEls[i].$el.parentNode.getBoundingClientRect().top
                    })
                }
                this.$emit('coords', coordsArray);
            },

            dropItNow(dragObj, dropIndex) {
                // console.log(dragObj);
                console.log('index is: '+dropIndex);

                // console.log(this.$refs['coordsSquares_'+this.uid][dropIndex].$el);



                console.log('x: '+this.$refs['coordsSquares_'+this.uid][dropIndex].$el.getBoundingClientRect().left +
                            ' y: '+this.$refs['coordsSquares_'+this.uid][dropIndex].$el.getBoundingClientRect().top);

                this.$store.dispatch('gameOS/updateIconPosition', {
                    id: dropIndex,
                    obj: dragObj
                });
            },

            // NOTE: eventually we'll use a UID to ud a file, in the short term, we'll compare objects

            // drop() {
            //     var dropTarget = event.dataTransfer.getData('text');
            //     var droppedGridSquareId = event.target.getAttribute('uid');

            //     console.log(JSON.parse(dropTarget));
            //     // console.log(data + ' dropped into: '+droppedGridSquareId);

            //     this.$store.dispatch('gameOS/updateIconPosition', {
            //         id: droppedGridSquareId,
            //         obj: JSON.parse(dropTarget)
            //     });
            // },
        }
    }
</script>

<style lang="scss" scoped>

    .icon-grid-wrapper {
        position: absolute; // may not need if icons are absolute
        top: 0;
        left: 0;
        width: 100%; // [LOCKED]]
        height: 100%; // [LOCKED] - to fix the issue - calculate the height and make this dynamic
        // background: #fcd652; //rgba(white, 0.2); // reference
    }

    //--------------------------------------------------------------------
    // ICONS LAYER (WRAPPER ONLY - zero width)
    // https://codepen.io/chriscoyier/pen/yHoeI
    // https://css-tricks.com/arranging-elements-top-bottom-instead-left-right-float/
    // https://stackoverflow.com/questions/20377837/how-to-access-custom-attributes-from-event-object-in-react
    //--------------------------------------------------------------------

    .icon-grid {
        display: flex; // [LOCKED]
        flex-direction: column; // [LOCKED]
        flex-wrap: wrap; // [LOCKED]
        position: absolute; // may not need if icons are absolute
        width: 0; // [LOCKED]] - squash all tiles down tight
        height: 100%; // [LOCKED]
        // z-index: 1; // keep as reference makes drop work
    }

    .is-constrained .icon-grid {
        width: 100%;
        height: 0;
        flex-direction: row; // [LOCKED]
    }

    //--------------------------------------------------------------------
    // GRID TILE (1x)
    //--------------------------------------------------------------------

    .icon-grid-square {
        display: inline-flex;
        // width: 100px;
        // height: 100px;
        padding: rem-calc(5);
        border: 1px solid black;
        opacity: 0.2;
    }

</style>